import { HOLD_UNTIL_REPLY_DELETE_REPLY_MODAL } from 'modules/workflows/constants/modals';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

type Props = {
  isOpen: boolean;
  handleDeleteReply: () => void;
  onClose: () => void;
};

export const content = {
  deleteButton: 'Delete',
};

export const HoldUntilReplyDeleteReplyModal = ({ isOpen, handleDeleteReply, onClose }: Props) => {
  return (
    <Modal
      id={HOLD_UNTIL_REPLY_DELETE_REPLY_MODAL}
      isModalOpen={isOpen}
      onClose={onClose}
      variant={MODAL_VARIANTS.WARNING}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>Delete reply</ModalHeader>
      <ModalBody>
        Are you sure want to delete reply? Your current progress will be discarded.
      </ModalBody>
      <ModalFooter>
        <Button autoFocus onClick={handleDeleteReply} variant={BUTTON_VARIANTS.DESTRUCTIVE}>
          {content.deleteButton}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
